export default __webpack_public_path__ + "device_doorbell_mini.6903b7a8.png";